module.exports = __webpack_public_path__ + "static/img/4.3fdd980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/4.png
// module id = VC+O
// module chunks = 0